import useSEO from "../hooks/useSEO";
import PageHero from "../components/PageHero";
import SoftwareEngineeringSection from "../components/SoftwareEngineeringSection";
import HowWeWork from "../components/HowWeWork";
import CTASection from "../components/CTASection";

export default function SoftwareEngineering() {
  useSEO({
    title: "Software Engineering | SefKam Digital Solutions",
    description: "Scalable backend systems, microservices, REST APIs, cloud architecture, DevOps and enterprise integrations engineered to scale.",
    path: "/software-engineering",
  });
  return (
    <>
      <PageHero
        eyebrow="Software Engineering"
        title="Engineering built to scale."
        subtitle="Scalable, secure and maintainable systems — built around business outcomes, not just technology."
      />
      <SoftwareEngineeringSection />
      <HowWeWork />
      <CTASection
        eyebrow="Let's build"
        title="Have a system to build or modernize?"
        subtitle="From greenfield products to legacy modernization, we can help you engineer it right."
        primary={{ label: "Start a Conversation", to: "/contact" }}
      />
    </>
  );
}
